import { CompanyCollectorSchemaRepository } from '@domain/company-collector-schema/repositories/company-collector-schema.repository';
import { CompanyCollectorSchemaRepositoryService } from '../repositories/company-collector-schema-repository.service';

export const CompanyCollectorSchemaProvider = [
  {
    provide: CompanyCollectorSchemaRepository,
    useClass: CompanyCollectorSchemaRepositoryService,
  },
];
